import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetHeaderDatesToConfig } from "../../redux/actions/homeAction";
import { Link, useLocation } from "react-router-dom";
import { getNavigationLinks, sidebarMapping } from "../../utils/common";
import SupportIcon from "@mui/icons-material/Support";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";

export const SideBar = ({ setShowSidebar }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    filterValue: { name, selectedPartnerRoleName },
    showHeader,
    showSidebar,
  } = useSelector((state) => state.homeReducer);
  const { tilesData } = useSelector((state) => state.homeReducer);

  let navigationLinks =
    tilesData &&
    tilesData.data &&
    tilesData.data.content &&
    getNavigationLinks(selectedPartnerRoleName, tilesData.data.content);

  let arr = navigationLinks && sidebarMapping(navigationLinks);

  // Handle body scroll when sidebar is open
  useEffect(() => {
    if (showSidebar) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove("sidebar-open");
    };
  }, [showSidebar]);

  // Check if current route is active
  const isActiveRoute = (route) => {
    return location.pathname === route;
  };

  return (
    <>
      <style>
        {`
          /* Sidebar Toggle Button */
          .sidebar-toggle-btn {
            position: fixed;
            top: 20px;
            left: 20px;
            z-index: 1001;
            background: #03007f;
            border: none;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            color: white;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .sidebar-toggle-btn:hover {
            background: #1a1a8c;
            transform: scale(1.05);
          }

          .sidebar-toggle-btn:active {
            transform: scale(0.95);
          }

          /* Sidebar Overlay */
          .sidebar-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
            z-index: 999;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
          }

          .sidebar-overlay.active {
            opacity: 1;
            visibility: visible;
          }

          /* Sidebar Container */
          .sidebar-container {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            z-index: 1000;
            transform: translateX(-100%);
            transition: transform 0.3s ease;
            display: flex;
            flex-direction: column;
          }

          .sidebar-container.active {
            transform: translateX(0);
          }

          /* Sidebar Navigation */
          .sidebar-nav {
            background: white;
            box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
            width: 280px;
            height: 100vh;
            overflow-y: auto;
            position: relative;
            display: flex;
            flex-direction: column;
          }

          /* Profile Card Styles */
          .profile-card {
            background: #03007f;
            border-radius: 12px;
            padding: 16px;
            margin: 16px;
            color: white;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }

          .profile-info {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
          }

          .profile-avatar {
            margin-right: 12px;
            flex-shrink: 0;
          }

          .profile-details {
            flex: 1;
            min-width: 0;
          }

          .profile-name {
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .profile-last-login {
            font-size: 12px;
            opacity: 0.9;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .profile-logout {
            border-top: 1px solid rgba(255, 255, 255, 0.2);
            padding-top: 12px;
          }

          .profile-logout-btn {
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 8px;
            color: white;
            padding: 8px 12px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 14px;
          }

          .profile-logout-btn:hover {
            background: rgb(255, 255, 255);
            color: #03007f;
            border-color: rgba(255, 255, 255, 0.5);
            transform: translateY(-1px);
          }

          .profile-logout-btn:hover .logout-text {
            color: #03007f;
          }

          .profile-logout-btn:hover svg {
            color: #03007f !important;
          }

          .profile-logout-btn:active {
            transform: translateY(0);
          }

          .logout-text {
            font-weight: 500;
          }

          /* Navigation List */
          .navigation-container {
            flex: 1;
            overflow-y: auto;
            padding: 16px 0;
          }

          .navigation-container::-webkit-scrollbar {
            width: 4px;
          }

          .navigation-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 2px;
          }

          .navigation-container::-webkit-scrollbar-thumb {
            background: #03007f;
            border-radius: 2px;
          }

          .navigation-container::-webkit-scrollbar-thumb:hover {
            background: #1a1a8c;
          }

          .nav-list {
            list-style: none;
            margin: 0;
            padding: 0;
          }

          .nav-item {
            margin-bottom: 4px;
          }

          .nav-link {
            display: flex;
            align-items: center;
            padding: 12px 16px;
            color: #333;
            text-decoration: none;
            transition: all 0.2s ease;
            position: relative;
            gap: 12px;
          }

          .nav-link:hover {
            background: rgba(3, 0, 127, 0.05);
            color: #03007f;
          }

          .nav-link.active {
            background: #03007f;
            color: white;
          }

          .nav-icon {
            flex-shrink: 0;
            width: 24px;
            height: 24px;
            display: flex;
            margin-left: 10px;
            align-items: center;
            justify-content: center;
          }

          .nav-text {
            font-weight: 500;
            font-size: 18px;
            white-space: wrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          /* Mobile Responsive */
          @media (max-width: 768px) {
            .sidebar-toggle-btn {
              top: 15px;
              left: 15px;
              width: 45px;
              height: 45px;
            }

            .sidebar-nav {
              width: 100%;
              max-width: 320px;
            }

            .profile-card {
              margin: 12px;
              padding: 12px;
            }

            .profile-name {
              font-size: 14px;
            }

            .profile-last-login {
              font-size: 11px;
            }

            .profile-logout-btn {
              padding: 6px 10px;
              font-size: 13px;
            }

            .profile-avatar i {
              font-size: 2rem !important;
            }

            .nav-link {
              padding: 10px 12px;
            }
          }

          /* Small Mobile Devices */
          @media (max-width: 480px) {
            .profile-card {
              margin: 8px;
              padding: 10px;
            }

            .profile-info {
              margin-bottom: 10px;
            }

            .profile-avatar {
              margin-right: 10px;
            }

            .profile-name {
              font-size: 13px;
            }

            .profile-last-login {
              font-size: 10px;
            }

            .profile-logout-btn {
              color: "blue";
              padding: 5px 8px;
              font-size: 12px;
            }
          }

          /* Prevent body scroll when sidebar is open */
          body.sidebar-open {
            overflow: hidden;
          }
        `}
      </style>

      {/* Background Overlay */}
      <div
        className={`sidebar-overlay ${showSidebar ? "active" : ""}`}
        onClick={() => setShowSidebar()}
      ></div>

      {/* Sidebar Container */}
      <div className={`sidebar-container ${showSidebar ? "active" : ""}`}>
        <nav className="sidebar-nav">
          <div className="profile-card">
            <div className="profile-info">
              <div className="profile-avatar">
                <i
                  className="fa fa-user-circle"
                  style={{ fontSize: "2.5rem", color: "#fff" }}
                ></i>
              </div>
              <div className="profile-details">
                <div className="profile-name">{name || "User"}</div>
                <div className="profile-last-login">
                  Last login:{" "}
                  {new Date().toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>
            </div>
            <div className="profile-logout">
              <form
                method="post"
                action={`${window.REACT_APP_LOGOUT_URL}`}
                style={{ margin: 0, padding: 0 }}
                onSubmit={(e) => {
                  e.preventDefault();
                  dispatch(resetHeaderDatesToConfig());
                  e.currentTarget.submit();
                }}
              >
                <button
                  type="submit"
                  className="profile-logout-btn"
                  title="Logout"
                >
                  <LogoutIcon sx={{ fontSize: "1.2rem" }} />
                  <span className="logout-text">Logout</span>
                </button>
              </form>
            </div>
          </div>

          {/* Navigation List */}
          <div className="navigation-container">
            <ul className="nav-list">
              {tilesData?.data?.extraData?.role === "NHQ" ? (
                <li className="nav-item">
                  <a
                    className="nav-link"
                    target="_blank"
                    href={`${window.REACT_APP_ADMIN_APP_URL}/dashboard-mapping`}
                  >
                    <div className="nav-icon">
                      <SupportIcon
                        sx={{ overflow: "visible" }}
                        fontSize="large"
                      />
                    </div>
                    <span className="nav-text">Ops Config</span>
                  </a>
                </li>
              ) : null}

              {arr &&
                arr.map(({ route, name, icon }, index) => {
                  const isActive = isActiveRoute(route);

                  return (
                    <li className="nav-item" key={route}>
                      <Link
                        to={route}
                        className={`nav-link ${isActive ? "active" : ""}`}
                        onClick={() => setShowSidebar()}
                      >
                        <div className="nav-icon">
                          {name === "Home" ? (
                            <HomeIcon fontSize="large" />
                          ) : (
                            <i className={icon} style={{ scale: "2" }}></i>
                          )}
                        </div>
                        <span className="nav-text">{name}</span>
                      </Link>
                    </li>
                  );
                })}
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};
